/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Details_Offline_SinceInputs */

const fr_vehicle_details_offline_since = /** @type {(inputs: Vehicle_Details_Offline_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`depuis le`)
};

const en_vehicle_details_offline_since = /** @type {(inputs: Vehicle_Details_Offline_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`since`)
};

/**
* | output |
* | --- |
* | "since" |
*
* @param {Vehicle_Details_Offline_SinceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_details_offline_since = /** @type {((inputs?: Vehicle_Details_Offline_SinceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Details_Offline_SinceInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_details_offline_since(inputs)
	return en_vehicle_details_offline_since(inputs)
});